import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { cleanData, fetchLogin } from "reducers/authSlice";
import { AppDispatch, RootState } from "store/store";
import { Link, useNavigate } from "react-router-dom";
import { Logo } from "assets/svg";
import { UserTypeEnum } from "common/enums/UserType.enum";
import { message } from "antd";

const Login = () => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const { userData, error } = useSelector((state: RootState) => state.auth);
  const [isChecked, setIsChecked] = useState(false);
  const { register, handleSubmit } = useForm({
    defaultValues: {
      email: "",
      password: "",
      remember_me: false,
    },
  });

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  };

  const onSubmit = (data: any) => {
    dispatch(fetchLogin(data));
  };

  useEffect(() => {
    if (userData) {
      if (userData.type === UserTypeEnum.COMPANY_BUYER) {
        navigate("/buyer/dashboard");
      }

      if (userData.type === UserTypeEnum.COMPANY_SELLER) {
        navigate("/seller/dashboard");
      }

      if (userData.type === UserTypeEnum.ADMIN) {
        navigate("/admin/dashboard");
      }
    }

    if (error) {
      message.error(error.response.data.message);
      dispatch(cleanData());
    }
  }, [error, userData]);

  return (
    <main className="bg--blur box">
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="w-full rounded-[20px] border-[8px] border-white bg-primary-light shadow-[0_0_15px_0_rgba(0,0,0,0.05)] flex flex-col items-center justify-center py-[52px] px-[22px]
        sm:max-w-[580px] sm:py-[72px] sm:px-[62px]"
      >
        <Logo
          className="flex justify-center items-center w-[200px] h-[81px] aspect-[1/1] mb-[30px]
             sm:w-[300px] sm:h-[121px] sm:mb-[40px]"
        />
        <h2
          className="text-[22px] not-italic font-bold text-primary mb-[15px]
        sm:text-[28px]"
        >
          ログイン
        </h2>
        <p className="text-[15px] font-normal leading-[160%] text-center mb-[30px] sm:text-[16px]">
          登録時に設定した
          <br className="sm:hidden" />
          メールアドレスとパスワードで <br /> ログインしてください。
        </p>

        {/* Username */}
        <label className="text-[22px] not-italic font-bold text-primary mb-[5px] sm:text-[18px]">
          メールアドレス
        </label>
        <input
          {...register("email", { required: true })}
          type="email"
          className="w-full h-[50px] px-[20px] rounded-[6px] mb-[15px] sm:mb-[20px] text-[18px]"
          placeholder="sample@example.com"
          required
        />

        {/* Password */}
        <label className="text-[22px] not-italic font-bold text-primary mb-[5px] sm:text-[18px]">
          パスワード
        </label>
        <input
          {...register("password", { required: true })}
          type="password"
          className="w-full h-[50px] px-[20px] mb-[20px] rounded-[6px] text-[18px]"
          placeholder="●●●●●●●●"
          required
        />

        {/* Checkbox */}
        <label className="flex items-center mb-[30px] cursor-pointer text-[15px] sm:text-[16px] sm:mb-[40px]">
          <div className="relative mr-[10px]">
            <input
              type="checkbox"
              {...register("remember_me")}
              className="sr-only"
              onChange={handleCheckboxChange}
            />
            <div className="w-[28px] h-[28px] bg-white border-0 rounded flex items-center justify-center">
              <svg
                className={`${isChecked ? "block" : "hidden"} w-5 h-5 text-primary`}
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M5 13l4 4L19 7"
                ></path>
              </svg>
            </div>
          </div>
          ログイン状態を保持する
        </label>

        <button
          type="submit"
          className="w-full bg-primary text-white py-2 rounded-[6px] mb-[15px] sm:max-w-[340px] sm:text-[18px] sm:mb-[20px]"
        >
          ログイン
        </button>

        <p className="text-black mb-[20px] sm:text-[14px]">
          パスワードを忘れた方は{" "}
          <Link className="underline" to="/forgot-password">
            こちら
          </Link>
        </p>

        <div className="w-full p-[15px] bg-white text-center rounded-[6px] sm:p-[20px]">
          <p className="text-primary text-[15px] mb-[7px] font-bold sm:mb-[10px]">
            まだアカウントをお持ちでない方
          </p>
          <p className="text-[13px] sm:text-[14px]">
            売り手企業の新規登録は
            <Link to="/seller/register" className="underline">
              こちら
            </Link>
            <br />
            買い手企業の新規登録は
            <Link to="/buyer/register" className="underline">
              こちら
            </Link>
          </p>
        </div>
      </form>
    </main>
  );
};

export default Login;
